import React, { Component } from "react";

class ZoomedPart extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			
		}
	}
 
	componentDidMount(){
		
	}
	
	
	render() {
		return (
			<div className="stream_pop_holder d-none" id="zoomed_part">
				<div className="close_zoomed" id="zoom_out_part"></div>
				<div className="zoom_container" id="zoom_content_part"></div>
			</div>		
	)}
}
export default ZoomedPart;
